import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalBody, { ModalProps } from './ModalBody';
import MaterialPDF from '../pdf/MaterialPDF';
import { useSystemConfig } from '../../hooks/useSystemConfig';
import { useMachinesQuery } from '../../hooks/queries/useMachinesQuery';
import { useToolsQuery } from '../../hooks/queries/useToolsQuery';
import { useTrucksQuery } from '../../hooks/queries/useTrucksQuery';
import { systemConfigKeyEnum } from '../../utils/enums';
import { PDFViewer, pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import { capitalizeFirstLetter } from '../../utils/capitalize';

interface MaterialPDFModalProps extends ModalProps {}

const MaterialPDFModal: React.FC<MaterialPDFModalProps> = ({ handleClose, open }) => {
    const { t } = useTranslation();
    const { getConfigValue } = useSystemConfig();
    const { data: dataMachines, isLoading: isMachinesLoading, refetch: refetchMachines } = useMachinesQuery({ queries: { active: true } });
    const { data: dataTools, isLoading: isToolsLoading, refetch: refetchTools } = useToolsQuery({ queries: { active: true } });
    const { data: dataTrucks, isLoading: isTrucksLoading } = useTrucksQuery({ queries: { active: true } });

    const doc = (
        <MaterialPDF
            logoUrl={getConfigValue(systemConfigKeyEnum.LOGO)}
            dataMachines={dataMachines || []}
            dataTools={dataTools || []}
            dataTrucks={dataTrucks?.filter((truck) => truck.truckCompanyId.isOwnCompany) || []}
            t={t}
        />
    );

    return (
        <ModalBody
            title={t('material')}
            open={open}
            handleClose={() => handleClose()}
            okText={t('download')}
            handleOk={async () => {
                const blob = await pdf(doc).toBlob();
                saveAs(blob, `${new Date().getFullYear()} - ${capitalizeFirstLetter(t('materialList'))}.pdf`);
                handleClose();
            }}
            width={'100%'}
        >
            <PDFViewer width="100%" height={'1500px'} >
                {doc}
            </PDFViewer>
        </ModalBody>
    );
};

export default MaterialPDFModal;
